import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      d="M1.25 9.167c.452 0 .833.364.833.833v2.917h10.834V10c0-.469.38-.833.833-.833h.417c.452 0 .833.336.833.805v3.782c0 .67-.526 1.246-1.172 1.246H1.176C.529 15 0 14.42 0 13.75V10c0-.469.381-.833.833-.833zM7.5 0c.237 0 .457.118.621.278l2.875 3.002c.165.161.254.382.254.61 0 .229-.09.446-.254.607l-.264.267c-.164.16-.387.25-.621.25-.234 0-.448-.088-.613-.249l-.935-.95V10c0 .47-.393.833-.875.833h-.437c-.482 0-.803-.363-.803-.833V3.816l-.952.948c-.165.16-.38.25-.614.25-.234 0-.452-.09-.616-.25L4.004 4.5c-.164-.16-.254-.374-.254-.602 0-.228.09-.442.255-.603L6.88.278C7.043.118 7.264 0 7.5 0z"
      transform="translate(4.5, 4.5)"
      fill={fill}
    />
  </g>
);

export default Icon;
